module.exports = __webpack_public_path__ + "static/media/Bulletin_Template_A.9598ae89.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductWizard/images/Bulletin_Template_A.JPG
// module id = 1074
// module chunks = 0